import * as Yup from 'yup'

const phoneRegExp = /^(((\+?64\s*[-.]?[3-9]|\(?0[3-9]\)?)\s*[-.]?\d{3}\s*[-.]?\d{4})|((\+?64\s*[-.(]?2\d{1}[-.)]?|\(?02\d{1}\)?)\s*[-.]?\d{3}\s*[-.]?\d{3,5})|((\+?64\s*[-.]?[-.(]?800[-.)]?|[-.(]?0800[-.)]?)\s*[-.]?\d{3}\s*[-.]?(\d{2}|\d{5})))$/

const getYupValidationSchema = values => {
    return Yup.object().shape({
        firstName: Yup.string()
            .trim()
            .required('First Name is required!'),
        lastName: Yup.string()
            .trim()
            .required('Last Name is required!'),
        mobile: Yup.string()
            .trim()
            .required('Mobile is required!')
            .matches(phoneRegExp, 'Invalid phone'),
        email: Yup.string()
            .trim()
            .email(),
    })
}

export default function validate(values) {
    return values => {
        const validationSchema = getYupValidationSchema(values)

        try {
            validationSchema.validateSync(values, { abortEarly: false })

            return {}
        } catch (error) {
            return getErrorsFromValidationError(error)
        }
    }
}

function getErrorsFromValidationError(validationError) {
    const FIRST_ERROR = 0
    return validationError.inner.reduce((errors, error) => {
        let path = error.path
        return {
            ...errors,
            [path]: error.errors[FIRST_ERROR],
        }
    }, {})
}
